import { AnyAppEvent, AppEvent } from "../appEvent.types";

const eventName = "pro-payment-method-accepted" as const;

export type ProPaymentMethodAcceptedEventData = {
  proPaymentMethodId: string;
};

export type ProPaymentMethodAcceptedEvent = AppEvent<
  typeof eventName,
  ProPaymentMethodAcceptedEventData
>;

export const isProPaymentMethodAcceptedEvent = (
  event: AnyAppEvent
): event is ProPaymentMethodAcceptedEvent => event.name === eventName;

export { eventName as proPaymentMethodAccepted };
